import _defineProperty from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["startIcon", "endIcon", "children", "variant", "rounding", "size", "color", "shape", "justify", "role", "type", "testId", "nostyle", "transparent", "underline", "isActive", "poppinsFont", "withoutPadding", "isLoading", "hoverColor", "fullUnderline"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { jsxs as z, jsx as r } from "react/jsx-runtime";
import { forwardRef as A } from "react";
import F from "classnames";
import { useStyleProps as k } from "../../hooks/useStyleProps.js";
import H from "./BaseButton.js";
import t from "./Button.module.scss.js";
import L from "../Spinner/Spinner.js";
var M = A(function (n, u) {
  var s = n.startIcon,
    i = n.endIcon,
    m = n.children,
    _n$variant = n.variant,
    o = _n$variant === void 0 ? "solid" : _n$variant,
    l = n.rounding,
    a = n.size,
    _n$color = n.color,
    e = _n$color === void 0 ? "primary" : _n$color,
    _n$shape = n.shape,
    c = _n$shape === void 0 ? "default" : _n$shape,
    _n$justify = n.justify,
    f = _n$justify === void 0 ? "center" : _n$justify,
    h = n.role,
    _n$type = n.type,
    I = _n$type === void 0 ? "button" : _n$type,
    P = n.testId,
    _n$nostyle = n.nostyle,
    _ = _n$nostyle === void 0 ? !1 : _n$nostyle,
    _n$transparent = n.transparent,
    v = _n$transparent === void 0 ? !1 : _n$transparent,
    d = n.underline,
    y = n.isActive,
    g = n.poppinsFont,
    x = n.withoutPadding,
    p = n.isLoading,
    b = n.hoverColor,
    B = n.fullUnderline,
    C = _objectWithoutProperties(n, _excluded),
    $ = s && /* @__PURE__ */r("span", {
      className: t.startIcon,
      children: s
    }),
    j = i && /* @__PURE__ */r("span", {
      className: t.endIcon,
      children: i
    }),
    w = (n.href ? "a" : "button") === "button" ? {
      type: I
    } : {},
    N = d === void 0 && (o === "text" || o === "link") ? !0 : d,
    _k = k(C),
    S = _k.styleProps,
    U = _k.componentProps;
  return /* @__PURE__ */z(H, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    role: h
  }, w), S), U), {}, {
    testId: P,
    ref: u,
    disabled: p || n.disabled,
    className: F(_ ? t.nostyle : [t.button, _defineProperty({}, t["rounding__".concat(l)], l), _defineProperty({}, t.transparent, v), _defineProperty({}, t["size__".concat(a)], a), _defineProperty({}, t["variant__".concat(o)], o), _defineProperty({}, t["color__".concat(e)], e), _defineProperty({}, t["shape__".concat(c)], c !== "default"), _defineProperty({}, t.underline, N), _defineProperty({}, t.fullUnderline, B), _defineProperty({}, t.isActive, y), _defineProperty({}, t.withoutPadding, x), t[o], n.height === "full" && t.fullHeight, n.width === "full" && t.fullWidth, e === "text-inverse" && t.colorTextInverse, f === "start" && t.justifyStart, g && t.poppinsFont, b && t.hoverBlue]),
    children: [$, p ? /* @__PURE__ */r(L, {}) : m, j]
  }));
});
export { M as default };